import { UPDATE_UTR_NUMBER_REQUEST, UPDATE_UTR_NUMBER_SUCCESS, UPDATE_UTR_NUMBER_FAILURE, UPDATE_UTR_NUMBER_RESET, } from "../../actions";
const initialState = {
    updateData: "",
    isLoading: false,
    error: null,
};
const UpdateUtrNumberReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_UTR_NUMBER_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null });
        case UPDATE_UTR_NUMBER_SUCCESS:
            return Object.assign(Object.assign({}, state), { updateData: action.payload, isLoading: false, error: null });
        case UPDATE_UTR_NUMBER_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case UPDATE_UTR_NUMBER_RESET:
            return Object.assign(Object.assign({}, state), { isLoading: false, updateData: null, error: null });
        default:
            return state;
    }
};
export default UpdateUtrNumberReducer;
